export function formatSoftwareTotalCountLabel(options: {
  template: string | undefined;
  start: number;
  count: number;
  total: number;
  stripParagraphTags?: boolean;
}): string {
  const { template, start, count, total, stripParagraphTags = false } = options;

  if (!template) {
    return `${start}-${count} / ${total}`;
  }

  let result = template
    .replaceAll('{start}', String(start))
    .replaceAll('{from}', String(start))
    .replaceAll('{count}', String(count))
    .replaceAll('{to}', String(count))
    .replaceAll('{total}', String(total));

  if (stripParagraphTags) {
    result = result.replaceAll('<p>', '').replaceAll('</p>', '');
  }

  return result;
}
